import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import CartReverseIcon from '../../icons/cartReverse'

class Cart extends React.Component {
  static propTypes = {
    user: PropTypes.object
  }

  render () {
    const { user } = this.props
    const cart = user.cart
    const cartEntryCount = cart && cart.entries ? cart.entries.length : null

    return (
      <li className='global-header-menu__list-item -background-light -border-radius'>
        <a href='/cart' className='global-header-menu__link fds-u-pr1'>
          <CartReverseIcon className='global-header-menu__icon'
            width='16px' height='16px' />
          <span className={
            classnames('global-header-menu__link-cart-amount',
              { 'fds-u-hidden': (cartEntryCount === null) })
            }>
            {cartEntryCount}
          </span>
        </a>
      </li>
    )
  }
}

export default Cart



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/cart.js